import Vue from 'vue'
import Router from 'vue-router'
import routes from "./routes-path";
import test_routes from "./test-routes-path";
// routes.push(...test_routes);
Vue.use(Router);

export default new Router({mode: 'history', routes: routes});




// WEBPACK FOOTER //
// ./src/router/router.js